<template>
  <div
    class="export_tip_cpn"
    @click="open"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: ['params'],
  methods: {
    open () {
      this.$emit('exportHandle', this.params)
      // const mesage = `<p>您已確認，在您點選“匯出”按鈕時，已具有獲得系統內全部會員資料、商品資料、訂單資料及相關資訊等的全部權利，並在使用過程中嚴格按照相關法律法規，包括但不限於已充分獲得授權可以收集個人資訊並儲存、使用、加工、傳輸、提供、公開該等資訊，否則，應由您出面自行處理並解決侵權事宜，並承擔由此引起的爭議及糾紛，如因此造成第三方損失的，則應向第三方賠償損失。</p>`
      // this.$alert(mesage, '通知訊息', {
      //   type: 'warning',
      //   confirmButtonText: '確定',
      //   dangerouslyUseHTMLString: true,
      //    customClass: 'export_tip_cpn'
      // })
      //   .then((res) => {
      //     console.log(this.params);
      //     this.$emit('exportHandle',this.params)
      //   })
      //   .catch((res) => {})
    }
  }
}
</script>
<style lang="scss">
.export_tip_cpn {
  display: inline-block;
  .el-message-box__status {
    position: absolute;
    top: 6% !important;
  }
}
</style>
